import type { MigrationStrategies } from 'rxdb';
import type { DeficiencyFiles } from './deficiencyFiles.types';

export const deficiencyFilesMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: DeficiencyFiles) => {
    const newDoc = {
      ...oldDoc,
      assetId: oldDoc.assetId || null,
      isReInspectedFile: oldDoc.isReInspectedFile || false,
      componentVersionInspectionId: oldDoc.componentVersionInspectionId || null,
      componentVersionId: oldDoc.componentVersionId || null,
      isActiveDeficiencyFile: oldDoc.isActiveDeficiencyFile || null,
    };
    return newDoc;
  },
};
